import { SET_BANNER_STATE } from "core-web/state/models/Header/constants";
import store from "core-web/state/store";

export const setBannerState = (bannerIsActive) => (dispatch) => {
    dispatch({
        type: SET_BANNER_STATE,
        bannerIsActive,
    });
};

export default (bannerIsActive) => store.dispatch(setBannerState(bannerIsActive));
